import { createContext } from 'react';
const PropertyCardContext = createContext({
    isCardSelected: false
});
export default PropertyCardContext;
